module.exports = __webpack_public_path__ + "img/DAY4-1.3f936c91.jpg";